import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
// import * as XLSX from "xlsx";
import { CSVLink } from "react-csv";
// import { jsPDF } from "jspdf";
// import "jspdf-autotable";
import {
  MdControlPoint,
  MdDelete,
  MdKeyboardDoubleArrowLeft,
  MdKeyboardDoubleArrowRight,
} from "react-icons/md";

import Response_Processing from "../../../../src/layout/Others/Response_Processing";
import Response_Loading_processing from "../../../../src/layout/Others/Response_Loading_processing";
import deleteitem from "../../../components/Images/deleteitem.svg";
import edititem from "../../../components/Images/edititem.svg";
import ExportIcon from "../../../components/Images/icons/Export_Icon_01.png";
import { ActionFormatterComponent } from "../../../components/CommonMethod/CommonBoostrapFormatter";
import AdminVideoStatus from "../../../components/CommonComponents/AdminVideoStatus";
import AdminSwitch from "../../../components/CommonComponents/AdminSwitch";
import AdminSliderModal from "../../../components/CommonComponents/AdminSliderModal";
import { toast } from "react-toastify";
import AdminCustomInput from "../../../components/CommonComponents/AdminCustomInput";
import MessageLabel from "../../../components/CommonComponents/MessageLabel";
import MessageHeading from "../../../components/CommonComponents/MessageHeading";
import { RxReload } from "react-icons/rx";
import { donwloadCSV, slugGenerator, videodownloadPDF, videodownloadXLSX } from "../../../components/CommonMethod/CommonMethods";
import MessageBox from "../../../components/CommonComponents/MessageBox";
import AdminNavbar from "../../../components/CommonComponents/AdminNavbar";
import AdminTooltip from "../../../components/CommonComponents/AdminTooltip";
import { IconDeleteFigma, IconEditFigma } from "../../../Assets/MyIcons";
import { FaEllipsisVertical } from "react-icons/fa6";
import FieldRenderer2 from "../../../CustomFields/FieldRenderer2";
import FieldRenderer from "../../../CustomFields/FieldRenderer";
import saveCustomFieldsStrict from "../../../CustomFields/saveCustomFieldsStrict";
import { adminApiHeader } from "../../../components/CommonApis/CommonApiUrl";
import { useMyContext } from "../../../components/Provider/CommonProvider";
function AdsCategories(props) {

  const { fetchRequest } = useMyContext()

  const [getAdsCategories, setAdsCategories] = useState([]);
  const [filteredAdsCategoriesData, setFilteredAdsCategoriesData] = useState([]);
  const [itemToDeleteAdsCategories, setItemToDeleteAdsCategories] = useState([]);
  const [modalCloseAdsCategories, setModalCloseAdsCategories] = useState(false);
  const [filter, setFilter] = useState("");
  const [loading, setLoading] = useState(true);
  const [processing, setProcessing] = useState(false);
  const [showOverlay, setShowOverlay] = useState(false);
  const [selectAll, setSelectAll] = useState(false);
  const [AdsCategories_name, setAdsCategories_name] = useState("");
  const [AdsCategories_slug, setAdsCategories_slug] = useState("");
  const [AdsCategories_status, setAdsCategories_status] = useState(0);
  const [showModal, setShowModal] = useState(false);
  const [currentItem, setCurrentItem] = useState(null);
  const [withOutRefresh, setWithoutRefresh] = useState(false)
  const [customFieldValues, setCustomFieldValues] = useState({});

  const BaseUrl = process.env.REACT_APP_Baseurl
  const bannerToggle = `${BaseUrl}/admin/advertisement/categories-status-update`


  const fetchDataAdsCategories = async (type) => {
    try {
      setLoading(true);
      const response = await axios.get(
        `${process.env.REACT_APP_Baseurl}/admin/advertisement/categories`,
        { headers: adminApiHeader }
      );
      setAdsCategories(response?.data?.data);
      setFilteredAdsCategoriesData(response?.data?.data);
      console.log("filteredAdsCategoriesData", filteredAdsCategoriesData);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching data:", error);
      setLoading(false);
    }


    const exportData = filteredAdsCategoriesData.map((item, index) => ({
      "S.NO": index + 1,
      "CATEGORY NAME": item?.name,
      "SLUG": item?.slug,
      "STATUS": item?.status,
    }));

    if (type === "CSV") {
      await donwloadCSV(exportData, "ADS-CATEGORY-LIST");
    } else if (type === "PDF") {
      await videodownloadPDF(exportData, "ADS-CATEGORY-LIST", [
        "S.NO", "CATEGORY NAME", "SLUG", "STATUS"
      ]);
    } else if (type === "XLSX") {
      await videodownloadXLSX(exportData, "ADS-CATEGORY-LIST", [
        "S.NO", "CATEGORY NAME", "SLUG", "STATUS"
      ]);
    }
  };

  useEffect(() => {
    fetchDataAdsCategories();
  }, [withOutRefresh]);

  const handleToggle = async (item) => {
    setCurrentItem(item);
    setShowModal(true);
  };

  const pagination = paginationFactory({
    page: 1,
    sizePerPage: 10,
    nextPageText: "Next",
    prePageText: "Prev",
    firstPageText: <MdKeyboardDoubleArrowLeft />,
    lastPageText: <MdKeyboardDoubleArrowRight />,
    showTotal: true,
    alwaysShowAllBtns: true,
    sizePerPageList: [
      { text: "5", value: 5 },
      { text: "10", value: 10 },
      { text: "All", value: filteredAdsCategoriesData?.length },
    ],
  });

  const selectRow = {
    mode: "checkbox",
    onSelect: (row, isSelect) => {
      if (row) {
        if (isSelect) {
          setItemToDeleteAdsCategories([...itemToDeleteAdsCategories, row.id]);
        } else {
          setItemToDeleteAdsCategories(itemToDeleteAdsCategories?.filter((id) => id !== row?.id));
        }
      }
    },
    onSelectAll: (isSelect, rows) => {
      if (isSelect) {
        const allIds = rows.map((r) => r.id);
        setItemToDeleteAdsCategories(allIds);
      } else {
        setItemToDeleteAdsCategories([]);
      }
    },
    style: { width: '50px' },
    selected: itemToDeleteAdsCategories,
    selectionHeaderRenderer: ({ mode, checked }) => (
      <div>
        <input type="checkbox" checked={checked} onChange={handleAll} />
      </div>
    ),
  };

  const actionFormatter = (data, row) => {
    return (
      <div className="editdropdown">
        <span className="editdropdown-button">
          <FaEllipsisVertical className="theme-text-color" />
        </span>
        <div className="editdropdown-menu">
          <Link to={`/edit_ads_categories/${row?.id}`}>
            <IconEditFigma styled={{ width: "20px", height: "20px" }} />
            <MessageBox text="Edit" classname='ms-2 theme-text-color'></MessageBox>
          </Link>

          <div
            onClick={() => openModalSingleDeleteAdsCategories(row?.id)}
            className="commonActionPadding"
          >
            <IconDeleteFigma styled={{ width: "20px", height: "20px" }} />
            <MessageBox text="Delete" classname='ms-2 theme-text-color'></MessageBox>
          </div>
        </div>
      </div>
    );
  };

  const actionFormattertext = (data, row) => {
    return (
      <div className="">
        <label>{row?.name}</label>
      </div>
    );
  };

  const columns = [
    {
      dataField: "AdsCategories_name",
      text: "Category Name",
      formatter: (cell, row) => <MessageBox text={row?.name} classname={"ms-3"} />
    },
    {
      dataField: "status",
      text: "Status",
      formatter: (cell, row) => <AdminSwitch name="banner" checked={cell == 1} onChange={() => handleToggle(row)} id={row?.id} />
    },
    {
      dataField: "action",
      text: "Actions",
      formatter: actionFormatter,
    },
  ];

  const handleFilterChangeAdsCategories = (event) => {
    const searchTerm = event.target.value.toLowerCase();
    setFilter(searchTerm);
    const filteredResults = getAdsCategories.filter((item) =>
      ["id", "name"].some(
        (property) =>
          typeof item[property] === "string" &&
          item[property].toLowerCase().includes(searchTerm)
      )
    );
    setFilteredAdsCategoriesData(filteredResults);
  };

  const handleClear = () => {
    fetchDataAdsCategories();
    setFilter("");
  };

  const handleAll = () => {
    setSelectAll(!selectAll);
    setItemToDeleteAdsCategories(
      selectAll ? [] : filteredAdsCategoriesData?.map((item) => item?.id)
    );
  };

  const closeAdsCategoriesModal = () => {
    setModalCloseAdsCategories(!modalCloseAdsCategories);
    setItemToDeleteAdsCategories([]);
  };

  const closeModal = () => {
    setShowModal(false);
  };

  const openModalSingleDeleteAdsCategories = (id) => {
    setItemToDeleteAdsCategories([id]);
    setModalCloseAdsCategories(true);
  };

  const openModalMultiDeleteAdsCategories = () => {
    setModalCloseAdsCategories(true);
  };

  const handleDeleteAdsCategoriesData = () => {
    closeAdsCategoriesModal();
    AdsCategoriesDeleteOperation();
  };

  const AdsCategoriesDeleteOperation = async () => {
    try {
      setLoading(true);
      for (const itemId of itemToDeleteAdsCategories) {
        const response = await axios.delete(
          `${process.env.REACT_APP_Baseurl}/admin/advertisement/categories-delete/${itemId}`,
          {
            headers: adminApiHeader,
          }
        );
        const result = response?.data;
        if (result?.status === true) {
          props?.setApiresponsealert(result);
          props?.setShowalert(true);
          setWithoutRefresh(!withOutRefresh);
        }
      }
      setLoading(false);
    } catch (err) {
      console.error(err);
      var errorMessage = err?.response?.data?.message;
      props?.setApiresponsealert({ status: false, message: errorMessage });
      props?.setShowalert(true);
      setLoading(false);
    }
  };

  const confirmToggle = async () => {
    setShowOverlay(true);
    setShowModal(false);
    try {
      const formData = {};
      const newStatus = currentItem?.status === 1 ? 0 : 1;
      formData['id'] = currentItem?.id;
      formData['status'] = newStatus;
      const response = await axios.post(`${bannerToggle}`, formData, { headers: adminApiHeader });
      const result = response.data
      if (result.status) {
        setWithoutRefresh(!withOutRefresh);
        toast.success(result?.message);
        setShowOverlay(false);
        setCurrentItem(null);
      }
      else {
        toast.error(result?.message);
        setShowOverlay(false);
      }
    } catch (err) {
      var errorMessage = err?.response?.data?.message;
      toast.error(errorMessage);
      setShowOverlay(false);
    }
  };

  const [validationMessageAdsCategories_name, setValidationMessageAdsCategories_name] =
    useState("");
  const [validationMessageAdsCategories_slug, setValidationMessageAdsCategories_slug] =
    useState("");
  const [isValidationHiddenAdsCategories_name, setIsValidationHiddenAdsCategories_name] =
    useState(true);
  const [isValidationHiddenAdsCategories_slug, setIsValidationHiddenAdsCategories_slug] =
    useState(true);

  const AdsCategories_nameInputRef = useRef(null);
  const AdsCategories_slugInputRef = useRef(null);

  const handleInput = (e) => {
    const { checked, name } = e.target;
    if (name === "status") {
      setAdsCategories_status(checked ? 1 : 0);
    }
  }

  const reloadAction = async () => {
    setWithoutRefresh(!withOutRefresh);
  };

  const handleBlurName = () => {
    if (!AdsCategories_slug) {
      generateSlug(AdsCategories_name);
    }
  };

  const generateSlug = (name) => {
    const slug = slugGenerator(name);
    setAdsCategories_slug(slug);
  };

  const handleInputKeyDownName = (event) => {
    if (event.key === "Enter" || event.key === "Tab") {
      console.log("AdsCategories_slug", AdsCategories_slug);
      if (!AdsCategories_slug) {
        generateSlug(AdsCategories_name);
      }
    }
  };

  const handleBlurSlugEdit = () => {
    generateSlug(AdsCategories_slug);
  };

  async function saveAdsCategories() {
    let focusInputRef = null;

    if (AdsCategories_name === "") {
      setValidationMessageAdsCategories_name("Ads Categories Name cannot be empty.");
      setIsValidationHiddenAdsCategories_name(false);
      focusInputRef = AdsCategories_nameInputRef;
    }

    if (AdsCategories_slug === "") {
      setValidationMessageAdsCategories_slug("Ads Categories Slug cannot be empty.");
      setIsValidationHiddenAdsCategories_slug(false);
      focusInputRef = AdsCategories_slugInputRef;
    }

    if (focusInputRef) {
      focusInputRef?.current?.focus();
      return;
    }

    const data = {
      name: AdsCategories_name,
      slug: AdsCategories_slug,
      status: AdsCategories_status
    }

    let firstApiStatus = false;
    let resultapi = null;
    setProcessing(true);
    setShowOverlay(true);

    try {
      const response = await fetchRequest({ method: 'POST', url: `${process.env.REACT_APP_Baseurl}/admin/advertisement/categories-store`, data: data })

      if (response?.status === true) {
        firstApiStatus = true;
        resultapi = response?.data;
        // save custom field values (strict)
        try {
          const createdId = response?.data?.id || response?.data?.data?.id;
          if (createdId) {
            await saveCustomFieldsStrict({ baseURL: process.env.REACT_APP_Baseurl, headers: adminApiHeader, entityType: 'ads_category', entityId: createdId, values: customFieldValues });
          }
        } catch (e) {
          toast.error(e.message);
          setProcessing(false);
          setShowOverlay(false);
          return;
        }
      }
    } catch (error) { }

    if (firstApiStatus) {
      setValidationMessageAdsCategories_name("");
      setValidationMessageAdsCategories_slug("");
      props?.setApiresponsealert(resultapi);
      props?.setShowalert(true);
      setTimeout(() => {
        window.location.reload();
      }, 3000);
    } else {
      if (resultapi === false) {
        var resultError = resultapi;

        console.log(resultError);
        props?.setApiresponsealert(resultError);
        props?.setShowalert(true);
        setIsValidationHiddenAdsCategories_name(false);
        setIsValidationHiddenAdsCategories_slug(false);
        setProcessing(false);
        setShowOverlay(false);
      }
    }
  }

  const handleOpenModal = () => {
    setAdsCategories_name("");
    setAdsCategories_slug("");
    setAdsCategories_status(0);
    setValidationMessageAdsCategories_name("");
    setValidationMessageAdsCategories_slug("");
  };

  return (
    <>
      <div
        className={`modal packageModel  ${modalCloseAdsCategories ? "show" : ""}`}
        tabIndex="-1"
        style={{
          display: modalCloseAdsCategories ? "block" : "none",
        }}
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Confirm Deletion</h5>
              <button
                type="button"
                className="btn-close"
                onClick={closeAdsCategoriesModal}
              ></button>
            </div>
            <div className="modal-body">
              {itemToDeleteAdsCategories?.length === 1 ? (
                <p className="fs-6">
                  {" "}
                  Are you sure you want to delete this AdsCategories ?
                </p>
              ) : (
                <p className="fs-6">
                  Are you sure you want to delete the selected AdsCategories ?
                </p>
              )}
            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-primary" onClick={closeAdsCategoriesModal} > Close </button>
              <button type="button" className="btn btn-danger" onClick={handleDeleteAdsCategoriesData} > Yes </button>
            </div>
          </div>
        </div>
      </div>

      <div className="modal fade" id="AdsCategories" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">
                Create Category
              </h5>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" ></button>
            </div>
            <div className="modal-body">

              <MessageLabel text={"Name"} className="mandatorySimple" />
              <AdminCustomInput id="ads-categories-name" type="text" name="AdsCategories_name" value={AdsCategories_name} onChange={(e) => setAdsCategories_name(e.target.value)} placeHolder={"Enter Category Name"} ref={AdsCategories_nameInputRef} error={validationMessageAdsCategories_name} onBlur={handleBlurName} onKeyDown={handleInputKeyDownName} />

              <MessageLabel text={"Slug"} className="mandatorySimple" />
              <AdminCustomInput id="ads-categories-slug" type="text" name="AdsCategories_slug" value={AdsCategories_slug} onChange={(e) => setAdsCategories_slug(e.target.value)} placeHolder={"Enter Category Slug"} ref={AdsCategories_slugInputRef} error={validationMessageAdsCategories_slug} onBlur={handleBlurSlugEdit} />

              <div className="d-flex justify-content-between mb-2 ">
                <div className="col-6 col-md-6 pe-2">
                  <MessageLabel text={"Status"} />
                </div>
                <div className="col-6 col-md-6 ps-2 text-end">
                  <AdminSwitch id="ads-category-status" name={'status'} checked={AdsCategories_status} onChange={handleInput} />
                </div>
              </div>

            <div className="card p-3 mt-3">
                {/* <MessageHeading text="Additional Fields" /> */}
                {/* Custom fields removed */}
                <FieldRenderer2
                  pageIdentifier={"ads_category.create"}
                  entityType={"ads_category"}
                  entityId={null}
                  onChange={setCustomFieldValues}
                />
                <FieldRenderer
                  pageIdentifier={"ads_category.create"}
                  entityType={"ads_category"}
                  entityId={null}
                  onChange={setCustomFieldValues}
                />
              </div>
            

            </div>
            <div className="modal-footer">
              <button type="submit" className="btn btn-primary ml-3 " onClick={saveAdsCategories} > Add Category </button>
            </div>
          </div>
        </div>
      </div>

      <div>
        {showOverlay && <Response_Processing></Response_Processing>}
      </div>

      {showModal && <AdminSliderModal className={currentItem?.status === 1 ? 'warningColorBg' : 'btn-success'} modalHeading={currentItem?.name} modelClose={showModal} sliderClose={closeModal} sliderAction={confirmToggle} modalDescription={`Do you want to ${currentItem?.status === 1 ? 'Disable' : 'Enable'} this category`} buttonText={currentItem?.status} />}
      <section className="section container-fluid pt-3">
        <div id="content-page" className="content-page">
          <div className="row pb-3 admin-section-title">
            <div className="col-md-8">
              <AdminNavbar heading={"Ads Category"} totalDataLength={getAdsCategories?.length} classname={"col-8"} />
            </div>
            <div className="col-md-4 mt-3 mt-md-0" align="right">
              {itemToDeleteAdsCategories?.length > 0 && (

                <button
                  type="button"
                  data-bs-dismiss="modal"
                  className="btn warningColorBg theme-button-text-color d-inline-flex fw-bold mb-3"
                  onClick={openModalMultiDeleteAdsCategories}
                >
                  <MdDelete className="exportIcon " /> Delete
                </button>
              )}
              <button
                type="button"
                className="admin-title ms-3 rounded-2 d-inline-flex align-items-center button-bg-color theme-button-text-color  text-decoration-hover  py-2 px-3"
                id="navigationLinkForAddPage"
                data-bs-toggle="modal"
                data-bs-target="#AdsCategories"
                onClick={handleOpenModal}
              >
                <MdControlPoint className="me-2 exportIcon " style={{ width: "22px", height: "22px" }} /> <MessageBox classname="admin-button-text " text={"Add Category"} />
              </button>
            </div>
          </div>
          <div className="iq-card mt-3">
            <div className="d-flex justify-content-between align-items-center flex-wrap mb-3 gap-3">
              <div className="filterContainer">
                <input
                  type="text"
                  placeholder="Search"
                  className="filter form-control "
                  value={filter}
                  onChange={handleFilterChangeAdsCategories}
                />
                {filter?.length > 0 && (
                  <button
                    type="button"
                    className="closeBtn"
                    onClick={handleClear}
                  >
                    <i className="fa fa-times"></i>
                  </button>
                )}
              </div>
              <div className='d-flex align-items-center'>
                <button id="reloadButton" className={`custom-tool-tip-parent bg-transparent reloadButton theme-text-color p-2 me-2  border border-2 rounded-circle theme-border-color `} onClick={reloadAction}>
                  <RxReload style={{ width: "18px", height: "15px" }} className={`${loading ? "rotate-load" : ""}`} />
                  <AdminTooltip text="Refresh" top={"-41px"} className="d-none custom-tool-tip" />
                </button>
                <div className="dropdown d-block ms-2 " key={"2"}>
                  <button className="btn btn-success dropdown-toggle d-flex hideArrow" type="button" id="exportAllButton" data-bs-toggle="dropdown" aria-expanded="false"  >
                    <span className="fw-bolder text-white">Export All</span>
                    <img src={ExportIcon} className="ms-2 exportIcon" alt="exportIcon" />
                  </button>
                  <ul className="dropdown-menu theme-bg-color" aria-labelledby="exportAllButton" >
                    <li id="exportallCSV" className="dropdown-item theme-text-color" onClick={() => fetchDataAdsCategories("CSV", "ALL")}>CSV</li>
                    <li id="exportallPDF" className="dropdown-item theme-text-color" onClick={() => fetchDataAdsCategories("PDF", "ALL")}>PDF</li>
                    <li id="exportallXLSX" className="dropdown-item theme-text-color" onClick={() => fetchDataAdsCategories("XLSX", "ALL")}>XLSX </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="bootstrapTable">
              <BootstrapTable
                keyField="id"
                columns={columns}
                data={filteredAdsCategoriesData}
                pagination={pagination}
                className="no-border-table theme-text-color"
                noDataIndication={
                  <div className="noRecord">
                    {loading ? (
                      <label>
                        {" "}
                        <Response_Loading_processing></Response_Loading_processing>
                        Loading...
                      </label>
                    ) : (
                      filteredAdsCategoriesData?.length <= 0 && (
                        <p>No AdsCategories Available. !!!</p>
                      )
                    )}
                  </div>
                }
                hover
                headerClasses="videoWidth"
                selectRow={selectRow}
                selectAll={selectAll}
              />
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default AdsCategories;
